module.exports = __webpack_public_path__ + "static/media/quote-werber-communication-fr.5b532d2f.png";